import React from "react";
import { Helmet } from "react-helmet-async";

import HomeHero from "../components/home/HomeHero";
import HomeAbout from "../components/global/HomeAbout";
import HomeFleet from "../components/home/HomeFleet";
import HomeServiceAreas from "../components/home/HomeServiceAreas";
import GlobalCta from "../components/global/GlobalCta";

import { homeSections } from "../components/home/homeSections";

export default function Home() {
  const renderSection = (section, index) => {
    switch (section.type) {
      case "hero":
        return <HomeHero key={index} />;

      case "fleet":
        return <HomeFleet key={index} />;

      case "about":
        return (
          <HomeAbout
            key={index}
            title={section.title}
            paragraphs={section.paragraphs}
            image={section.image}
            imageAlt={section.imageAlt}
            reverse={section.reverse}
            items={section.items}
            note={section.note}

            // WhatsApp
            whatsappButton={section.whatsappButton}
            whatsappText={section.whatsappText}
            whatsappLink={section.whatsappLink}

            // ⭐ ADD THIS
            background={section.background}
          />
        );

      case "service-areas":
        return <HomeServiceAreas key={index} />;

      case "home-cta":
        return (
          <GlobalCta
            key={index}
            title={section.title}
            description={section.description}
          />
        );

      default:
        return null;
    }
  };

  return (
    <>
      <Helmet>
        <title>Chiller Fleet Transport Dubai | Refrigerated Van & Truck Rental UAE</title>
        <meta name="description" content="Chiller Fleet offers 24/7 chiller van & freezer truck rentals across Dubai, Abu Dhabi & UAE for food, pharma & frozen goods cold chain transport." />
        <meta property="og:title" content="Chiller Fleet Transport Dubai | Refrigerated Van & Truck Rental UAE" />
        <meta property="og:description" content="Chiller Fleet offers 24/7 chiller van & freezer truck rentals across Dubai, Abu Dhabi & UAE for food, pharma & frozen goods cold chain transport." />
        <link rel="canonical" href="https://chillerfleet.com/" />
        <meta property="og:url" content="https://chillerfleet.com/" />
        <meta name="twitter:title" content="Chiller Fleet Transport Dubai | Refrigerated Van & Truck Rental UAE" />
        <meta name="twitter:description" content="Chiller Fleet offers 24/7 chiller van & freezer truck rentals across Dubai, Abu Dhabi & UAE for food, pharma & frozen goods cold chain transport." />
      </Helmet>

      {homeSections.map(renderSection)}
    </>
  );
}